import { post } from '@/util/http'

/**
 * 根据id获取信息
 *
 * @return Result
 */
export const getResidentOffice = params => post(`/residentOffice/get`);
/**
 * 获取代表信息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const getRepresentative = params => post(`/representative/get`, params);

/**
 * 获取变更机构信息 - 当前登录机构查询接口
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const getChangeResidentOffice = params => post(`/org/changeResidentOffice/get`, params);
/**
 * 根据变更机构id更新实体，仅更新非空字段
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateChangeResidentOffice = params => post(`/org/changeResidentOffice/update`, params);
/**
 * 根据变更机构id提交实体
 *
 * @param {Object} vo id
 * @return Result
 */
export const submitChangeResidentOffice = params => post(`/org/changeResidentOffice/submit`, params);

/**
 * 获取变更机构代表信息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const getChangeChiefRepresentative = params => post(`/org/changeRepresentative/get`, params);
/**
 * 分页查询获取列表
 *
 * @param {Object} pager 通用查询分页对象
 * @param {Object} vo    接收查询参数的VO对象, 支持fuzzyText属性模糊查询
 * @return Result
 */
export const selectPagerChangeChiefRepresentative = params => post(`/org/changeRepresentative/selectPage`, params);
/**
 * 根据变更代表id更新实体，仅更新非空字段
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const saveChangeChiefRepresentative = params => post(`/org/changeRepresentative/save`, params);

/**
 *
 * 代表/职员变更申请
 * @return Result
 */
export const submitChangeChiefRepresentative = params => post(`/org/changeRepresentative/submit`, params);

/**
 * 获取变更机构雇员信息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const getChangeChineseEmployee = params => post(`/org/changeChineseEmployee/get`, params);
/**
 * 分页查询获取列表
 */
export const selectPagerChangeChineseEmployee = params => post(`/org/changeChineseEmployee/selectPage`, params);
/**
 * 根据变更雇员id更新实体，仅更新非空字段
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const saveChangeChineseEmployee = params => post(`/org/changeChineseEmployee/save`, params);
/**
 * 根据变更代表id, 变更联系人
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const bePromotedChangeChineseEmployee = params => post(`/org/changeChineseEmployee/bePromoted`, params);
/**
 *
 *
 * @return Result
 */
export const submitChangeChineseEmployee = params => post(`/org/changeChineseEmployee/submit`, params);

//============================================================================================================
/**
 * 分页查询获取列表
 *
 * @param {Object} pager 通用查询分页对象
 * @param {Object} vo    接收查询参数的VO对象
 * @return Result
 */
export const getChangeApplicationSelectPage = params => post(`/org/changeApplication/selectPage`, params);
/**
 * 分页查询获取列表 - 审批查询
 *
 * @param {Object} pager 通用查询分页对象
 * @param {Object} vo    接收查询参数的VO对象
 * @return Result
 */
export const getChangeApplicationSelectPageThis = params => post(`/org/changeApplication/selectPage/this`, params);
/**
 * 获取变更机构信息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const queryChangeResidentOffice = params => post(`/org/changeResidentOffice/query`, params);
/**
 * 机构变更领导审批通过
 *
 * @param {String} residentOfficeId 机构变更id
 * @return Result
 */
export const changeResidentOfficeApprove = params => post(`/org/changeResidentOffice/approve`, params);
/**
 * 机构补填领导审批驳回
 *
 * @param {String} residentOfficeId 机构变更id
 * @param {String} rejectReason 驳回原因
 * @return Result
 */
export const changeResidentOfficeReject = params => post(`/org/changeResidentOffice/reject`, params);
/**
 * 获取变更代表信息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const queryChangeRepresentative = params => post(`/org/changeRepresentative/queryPage`, params);
/**
 * 代表变更领导审批通过
 *
 * @param {String} applicationId 代表变更id
 * @return Result
 */
export const changeeRepresentativeApprove = params => post(`/org/changeRepresentative/approve`, params);
/**
 * 代表变更 领导审批驳回
 *
 * @param {String} applicationId 代表变更id
 * @param {String} rejectReason 驳回原因
 * @return Result
 */
export const changeeRepresentativeReject = params => post(`/org/changeRepresentative/reject`, params);
/**
 * 获取雇员代表信息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const queryChangeEmployee = params => post(`/org/changeChineseEmployee/queryPage`, params);
/**
 * 雇员补填领导审批通过
 *
 * @param {String} applicationId 雇员变更id
 * @return Result
 */
export const changeEmployeeApprove = params => post(`/org/changeChineseEmployee/approve`, params);
/**
 * 雇员补填领导审批驳回
 *
 * @param {String} applicationId 雇员变更id
 * @param {String} rejectReason 驳回原因
 * @return Result
 */
export const changeEmployeeReject = params => post(`/org/changeChineseEmployee/reject`, params);
/**
 * 删除变更雇员信息
 * @param {String} id 雇员变更id
 */
export const removeChangeEmployee = params => post(`/org/changeChineseEmployee/remove`, params);
/**
 * 删除变更代表信息
 * @param {String} id 雇员变更id
 */
export const removeChangeRepresentative= params => post(`/org/changeRepresentative/deleteById`, params);
/**
 * 根据变更雇员id更新实体离职日期
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateLeaveDate = params => post(`/org/changeChineseEmployee/updateLeaveDate`, params);
/**
 * 根据变更代表id更新实体离职日期
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateRepresentativeLeaveDate = params => post(`/org/changeRepresentative/updateLeaveDate`, params);
/**
 * 查询变更对象
 *
 */
export const selectOneChangeApplication = params => post(`/org/changeApplication/selectOne`, params);

/**
 * 获取变更机构名称信息 - 当前登录机构查询接口
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const getChangeOrgNameInfo = params => post(`/org/changeResidentOffice/getChangeNameInfo`, params);
/**
 * 修改变更机构名称信息
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateChangeOrgName = params => post(`/org/changeResidentOffice/updateName`, params);

/**
 * 获取变更机构地址信息 - 当前登录机构查询接口
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const getChangeOrgAddressInfo = params => post(`/org/changeResidentOffice/getChangeOrgAddressInfo`, params);

/**
 * 修改变更机构dizhi 信息
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateChangeOrgAddress = params => post(`/org/changeResidentOffice/updateAddress`, params);

/**
 * 分页查询获取首席代表变更列表
 * @param {Object} pager 通用查询分页对象
 * @param {Object} vo    接收查询参数的VO对象, 支持fuzzyText属性模糊查询
 * @return Result
 */
export const selectPagerChangeChief = params => post(`/org/changeChief/selectPage`, params);

/**
 * 获取变更首席代表/中心主任信息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const getChangeChief = params => post(`/org/changeChief/get`, params);
/**
 * 根据变更首代id更新实体，仅更新非空字段
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const saveChangeChief = params => post(`/org/changeChief/save`, params);

/**
 * 原代表查询-字典
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const getOriginalRepresentative = params => post(`/org/changeChief/getRepresentative`);
/**
 * 代表更新为首代
 */
export const representativeUpdateChangeChief = params => post(`/org/changeChief/updateToChangeChief`, params);
/**
 * 变更代表对象更新职务
 */
export const updatePost = params => post(`/org/changeChief/updateChangePost`, params);
/**
 * 变更代表对象更新任职延期
 */
export const updateExtensionOfAppointment = params => post(`/org/changeChief/updateExtension`, params);
/**
 *
 * 首席代表/中心主任变更申请
 */
export const submitChangeChief = params => post(`/org/changeChief/submit`, params);
/**
 * 首席代表变更 领导审批驳回
 */
export const changeeChiefReject = params => post(`/org/changeChief/reject`, params);
/**
 * 变更首席代表领导审批通过
 */
export const changeeChiefApprove = params => post(`/org/changeChief/approve`, params);
/**
 * 取消代表信息变更
 */
export const resetChangeRepresentative = params => post(`/org/changeRepresentative/reset`, params);
/**
 * 取消雇员信息变更
 */
export const resetChangeEmployee = params => post(`/org/changeChineseEmployee/reset`, params);

/**
 * 申请机构注销
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateChangeCancel = params => post(`/org/changeResidentOffice/updateChangeCancel`, params);
/**
 * 获取变更机构申请信息
 */
export const getChangeCancelInfo = params => post(`/org/changeResidentOffice/getChangeCancelInfo`, params);

/**
 * 机构变更机构注销审批通过
 *
 */
export const changeCancelOrgApprove = params => post(`/org/changeResidentOffice/approveCancelOrg`, params);

/**
 * 编辑解锁变更代表
 */
export const unlockChangeRepresentative = params => post(`/org/changeRepresentative/unlock`, params);
